export class OrganizationParticipantExpression { 
    id: string;
    name: string;
    actionScope: ActionScope;
    organizationLevel: OrganizationLevel;
    organizationId: string ;
    organizationCode: string ;
    organizationName: string ;
    includeChildren: boolean ;
    parentsUntil: boolean;                          
    tag: string 
    condition:string;
}

export enum ActionScope {
    /**
     * 指派
     */
    AssignUser = 'AssignUser',
    /**
     * 移交
     */
    Transfer = 'Transfer',
    /**
     * 征询
     */
    AddSignFront = 'AddSignFront',
    /**
     * 加签
     */
    AddSignBehind = 'AddSignBehind',
    /**
     * 知会
     */
    Notify = "Notify",
}
export enum OrganizationLevel {
    /**
     * 部门
     */
    DEPARTMENT = 'DEPARTMENT',
    /**
     * 单位
     */
    UNIT = 'UNIT',
    /**
    * 默认值
    */
    DEFAULT = 'DEFAULT',

    VARORGANIZATION = 'VARORGANIZATION',

    // ASSIGNORGANIZATION = 'ASSIGNORGANIZATION'
}

